var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React from "react";
import styled from "styled-components";
import { Id } from "core/utils";
import { mq } from "core/styles/snippets";
import { renderContentBlocks } from "contentBlock";
export var prepView = function (blocks) {
    return function (_a) {
        var data = _a.data;
        return (React.createElement(Container, { "data-result": Id.result.success, "data-component": Id.component.video, "data-uuid": data.uuid }, renderContentBlocks(blocks, data)));
    };
};
var Container = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  width: 100%;\n\n  > * {\n    margin-bottom: 2rem !important;\n\n    ", " {\n      margin-bottom: 3rem !important;\n    }\n\n    ", " {\n      margin-bottom: 3.5rem !important;\n    }\n\n    ", " {\n      margin-bottom: 5rem !important;\n    }\n  }\n"], ["\n  width: 100%;\n\n  > * {\n    margin-bottom: 2rem !important;\n\n    ", " {\n      margin-bottom: 3rem !important;\n    }\n\n    ", " {\n      margin-bottom: 3.5rem !important;\n    }\n\n    ", " {\n      margin-bottom: 5rem !important;\n    }\n  }\n"])), mq.minWidth("64rem"), mq.minWidth("90rem"), mq.minWidth("120rem"));
var templateObject_1;
